export default __webpack_public_path__ + "static/media/Google_Translate.a234e3ed.png";